import { render } from "./TweakPane.vue?vue&type=template&id=4ff5c14e"
import script from "./TweakPane.vue?vue&type=script&lang=js"
export * from "./TweakPane.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__